/** Synthesised notification chime using the Web Audio API (no audio files needed). */

// Module-level AudioContext singleton — created lazily on first play
let audioCtx: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  try {
    if (!audioCtx) {
      audioCtx = new AudioContext();
    }
    if (audioCtx.state === 'suspended') {
      void audioCtx.resume();
    }
    return audioCtx;
  } catch {
    // AudioContext unavailable (e.g. SSR, unsupported browser)
    return null;
  }
}

/**
 * Play a gentle two-note ascending chime (A4 → E5) for notifications.
 * Quieter than session sounds (gain 0.08), 0.35s duration.
 * Silently fails if AudioContext is unavailable.
 */
export function playNotificationSound(): void {
  const ctx = getAudioContext();
  if (!ctx) return;

  const now = ctx.currentTime;

  const oscillator = ctx.createOscillator();
  const gain = ctx.createGain();

  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(440, now); // A4
  oscillator.frequency.setValueAtTime(659.25, now + 0.12); // E5

  gain.gain.setValueAtTime(0.08, now);
  gain.gain.exponentialRampToValueAtTime(0.001, now + 0.35);

  oscillator.connect(gain);
  gain.connect(ctx.destination);

  oscillator.start(now);
  oscillator.stop(now + 0.35);
}
